import React from 'react';
import { Discount } from '../../../../types/discounts';
import DiscountItem from './discountItem';

interface DiscountsListProps {
    discounts: Discount[];
    setActiveDiscount: (discountId: string) => void;
}

const DiscountsList = (
    {
        discounts,
        setActiveDiscount,
    }: DiscountsListProps
) => {
    return (
        <div>
            {discounts.map(discount => <DiscountItem onClick={(discountId) => setActiveDiscount(discountId)} key={discount.id} discount={discount} />)}
        </div>
    );
};

export default DiscountsList;
